module.exports = __webpack_public_path__ + "static/media/veneto-village-11.fcdf6375.jpg";